import { clearToken } from "auth/token";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    clearToken();
    navigate("/authentication/sign-in/illustration", { replace: true });
  }, [navigate]);

  return null;
}
